import {isEmpty, debounce, forEach, cloneDeep} from "lodash";
import requestConfig from '../helpers/RequestConfig.js';

export { requestConfig as SearchCitiesConfig };

// TODO: move CityAndStateMixin in vue-modules/core/Mixins/Address
// TODO: rename to SearchByCityAndStateMixin
// TODO: changes should be reflected in re-web, re-manager and pro
export default {
    data() {
        return {
            cityAndState: '',
            cities: [],
            citiesCache: {},
        };
    },

    methods: {
        // This search is made using 'api/v1/cities/search' from Core-API
        // doesn't contain all the cities
        onInputCityAndState: debounce(async function (inputEvent) {
            inputEvent = inputEvent.trim();
            this.cityAndState = inputEvent;

            if (inputEvent.length <= 1) {
                this.cities = [];

                return;
            }

            if (this.citiesCache[inputEvent]) {
                this.cities = [];
                this.cities.push( ...Object.values(this.citiesCache[inputEvent]));

                return;
            }

            const params = {};
            params.name = inputEvent;

            if (inputEvent.includes(',')) {
                this.getParamsFromCityAndState(inputEvent, params);
            }

            let requestData = {
                fieldset: 'marketplaceDirectory',
                filter: {'params': params},
                page: 1,
                pageSize: 10,
            };

            try {
                const response = await this.performRequest(requestData);
                let citiesCollection = [];
                const data = response?.data?.data;

                if (!isEmpty(data)) {
                    forEach(data, elem => {
                        citiesCollection.push({...elem.attributes});
                    });
                }

                this.citiesCache[inputEvent] = {...citiesCollection};
                this.cities = citiesCollection;
            } catch (e) {
                console.warn(e);
            }
        }, 500),

        getParamsFromCityAndState(inputEvent, params) {
            // Split inputEvent in two parts, Example: Austin, TX firstPart will be 'Austin', and second 'TX'
            let firstPart, secondPart;
            [firstPart, secondPart] = inputEvent.split(',');
            firstPart = firstPart.trim();
            secondPart = secondPart.trim();

            // Get state
            if (secondPart.length === 2) {
                params.state = secondPart;
            }

            // Get city
            if (firstPart.length > 2) {
                params.name = firstPart;
            }

            // Switch state and city if user input text like TX,Austin
            if (firstPart.length === 2 && secondPart.length > 2) {
                params.name = secondPart;
                params.state = firstPart;
            }
        },
        async performRequest(requestData) {
            return await requestConfig.xhrLib.post(
                requestConfig.apiUrl(this.resource) + '/cities/search',
                requestData
            );
        },
    },
};
